module.exports = require("react-feather");